import React from "react";
import { useTranslation } from "react-i18next";
import { LinkButton } from "./LinkButton";

export const DifferentEmailLink: React.FC<{
  online: boolean;
  onClick(): void;
}> = ({ online, onClick }) => {
  const { t } = useTranslation();
  return (
    <LinkButton onClick={onClick} disabled={!online}>
      {t("Log in with a different email")}
    </LinkButton>
  );
};

export const ForgetEmailLink: React.FC<{
  email: string;
  onForget(): void;
}> = ({ email, onForget }) => {
  const { t } = useTranslation();
  return (
    <LinkButton
      onClick={onForget}
      ariaLabel={`${t("Forget this email")} ${email}`}
    >
      {t("Forget this email")}
    </LinkButton>
  );
};
